export const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:1338';
export const downloadUrl = process.env.REACT_APP_DOWNLOAD_URL || 'http://localhost:1338';
